@let trip = $trip | async;
<!---->
@let tripsFetchedAt = $tripsFetchedAt | async;
<!---->

<div class="container">
  <mat-card>
    <mat-card-content>
      @if (trip) {
      <div class="pointer" (click)="navToDriverDetails(trip.driverId)">
        <display-input
          title="Driver"
          [value]="trip.driver?.profile?.firstName + ' ' + trip.driver?.profile?.lastName"
        />
      </div>
      <display-input
        title="Vehicle"
        [value]="trip.vehicle?.year + ' ' + trip.vehicle?.manufacturer + ' ' + trip.vehicle?.model"
      />
      <display-input
        title="Total Weight (kg)"
        [value]="trip.totalWeight.toString()"
      />
      <display-input
        title="Total Volume (cm³)"
        [value]="trip.totalVolume.toString()"
      />
      <display-input
        title="Status"
        [value]="utils.getTripStatus(trip.status)"
      />
      <display-input
        title="Planned At"
        [value]="(trip.plannedAt | date:'dd/MM/yyyy HH:mm') || '-'"
      />
      <display-input
        title="Started At"
        [value]="(trip.startedAt | date:'dd/MM/yyyy HH:mm') || '-'"
      />
      <display-input
        title="Completed At"
        [value]="(trip.completedAt | date:'dd/MM/yyyy HH:mm') || '-'"
      />

      } @if (!trip && !tripsFetchedAt) {
      <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner
          class="me-2"
          mode="indeterminate"
          color="primary"
          diameter="30"
        />
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
<div>
  @if (trip) {
  <mat-card class="mt-3">
    <mat-card-header>
      <mat-card-title class="mb-1">Service Requests</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-service-requests-table
        [serviceRequests]="trip.serviceRequests ?? []"
      ></app-service-requests-table>
    </mat-card-content>
  </mat-card>
  }
</div>
